import {
  isTeacherWorkAvailable,
  readAssignment,
  readAssignments,
  readClassroomLearners,
  readClassroomOverview,
  readLearnerDetail,
  readReviewQueue,
} from "./teacherWorkApi";
import usePolledResource from "./usePolledResource";

// The classroom workspace's snapshots. Each is a projection the gateway builds
// from canonical records; this app neither stores nor recomputes them.

export const useClassroomOverview = (classroomId) =>
  usePolledResource(() => readClassroomOverview(classroomId), `overview:${classroomId}`, {
    enabled: isTeacherWorkAvailable(),
  });

export const useClassroomLearners = (classroomId) =>
  usePolledResource(() => readClassroomLearners(classroomId), `learners:${classroomId}`, {
    enabled: isTeacherWorkAvailable(),
  });

// The gateway serves at most 100 per page; newest first.
export const useReviewQueue = (classroomId, limit = 100) =>
  usePolledResource(
    () => readReviewQueue(classroomId, { limit }),
    `work:${classroomId}:${limit}`,
    { enabled: isTeacherWorkAvailable() }
  );

export const useLearnerDetail = (classroomId, learnerId) =>
  usePolledResource(
    () => readLearnerDetail(classroomId, learnerId),
    `learner:${classroomId}:${learnerId}`,
    { enabled: isTeacherWorkAvailable() }
  );

// Handoff 007: assignments and their derived learner progress. Progress is
// the gateway's projection of assignment + attempts; nothing is stored here.
export const useAssignments = (classroomId) =>
  usePolledResource(() => readAssignments(classroomId), `assignments:${classroomId}`, {
    enabled: isTeacherWorkAvailable(),
  });

export const useAssignment = (classroomId, assignmentId) =>
  usePolledResource(
    () => readAssignment(classroomId, assignmentId),
    `assignment:${classroomId}:${assignmentId}`,
    { enabled: isTeacherWorkAvailable() }
  );
